import types from './types';

function documentSigningReducer(state, action) {
  switch(action.type) {
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation}
    case types.SET_CREDIT:
      return {...state, credit: action.credit}
    case types.SET_DOWNLOAD_DOCUMENTS:
      return {...state, downloadDocuments: action.downloadDocuments}
    case types.SET_DISABLED_BUTTON:
      return {...state, disabledButton: action.disabledButton}
    case types.SET_UPLOAD_DOCUMENTS:
      return {...state, uploadDocuments: action.file}
    case types.SET_END_CREDIT_PROCESS:
      return {...state, endCreditProcess: action.endCreditProcess}
    default:
      return state;
  }
}

export default documentSigningReducer;
